import ProductsEnhanced from './ProductsEnhanced'

export default function Products() {
  return <ProductsEnhanced />
}